import { PlayerData } from '../Api/players/players.types'

export type SearchablePlayer = PlayerData

export interface SearchResult<T extends SearchablePlayer> {
  player: T
  score: number
  matchType: 'lastName' | 'firstName' | 'teamName' | 'fullName'
  matchIndex: number
}

export interface SearchOptions {
  caseSensitive?: boolean
  minSearchLength?: number
  maxResults?: number
  includeTeamSearch?: boolean
}

export interface SearchWeights {
  lastName: number
  firstName: number
  teamName: number
  fullName: number
  exactMatch: number
  prefixMatch: number
  substringMatch: number
}

export const DEFAULT_SEARCH_WEIGHTS: SearchWeights = {
  lastName: 3,
  firstName: 2,
  teamName: 1,
  fullName: 4, // High priority, between lastName and firstName
  exactMatch: 10,
  prefixMatch: 5,
  substringMatch: 1,
}

export const DEFAULT_SEARCH_OPTIONS: Required<SearchOptions> = {
  caseSensitive: false,
  minSearchLength: 1,
  maxResults: 50,
  includeTeamSearch: true,
}